/**
 * The AI assistants that reliably support opening with a prefilled prompt via a
 * `?q=` query parameter. Shared by the docs "Ask AI" buttons and the report
 * "Chat with this report" buttons. Gemini is intentionally excluded — it has no
 * reliable URL-prefill mechanism.
 */

export interface AiAssistant {
  id: string;
  label: string;
  /** Public path to the assistant's logo SVG. */
  logo: string;
  /** Build the deep-link URL that opens the assistant with the prompt prefilled. */
  urlFor: (prompt: string) => string;
}

export const AI_ASSISTANTS: AiAssistant[] = [
  {
    id: "chatgpt",
    label: "ChatGPT",
    logo: "/images/chatgpt-logo.svg",
    urlFor: (prompt) => `https://chatgpt.com/?q=${encodeURIComponent(prompt)}`,
  },
  {
    id: "claude",
    label: "Claude",
    logo: "/images/claude-logo.svg",
    urlFor: (prompt) => `https://claude.ai/new?q=${encodeURIComponent(prompt)}`,
  },
  {
    id: "perplexity",
    label: "Perplexity",
    logo: "/images/perplexity-logo.svg",
    urlFor: (prompt) =>
      `https://www.perplexity.ai/search/new?q=${encodeURIComponent(prompt)}`,
  },
  {
    id: "copilot",
    label: "Copilot",
    logo: "/images/microsoft-copilot-logo.svg",
    urlFor: (prompt) =>
      `https://copilot.microsoft.com/?q=${encodeURIComponent(prompt)}`,
  },
];
